export interface IWebviewParams {
	/**Url que l'on souhaite afficher dans la webview */
	source: string;
	/**Classe CSS a appliquer a l'iframe */
	cssClass: string;
}